export default [
    // members sidebar index route
    {
        path: '/settings',
        component: () => import(/* webpackChunkName: "residents-index" */ '@/views/settings/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'settings.index',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/settings/selectview.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
